// extracted by mini-css-extract-plugin
export default {"wrapper":"SeamlessScene_wrapper__LLMsn","scene":"SeamlessScene_scene__BM6a6"};